"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CausticCircleFilled = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var CausticCircleFilled = function CausticCircleFilled(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8 16A8 8 0 108 0a8 8 0 000 16z",
    fill: "#F6F8FC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.55 7.548a.45.45 0 01.056.898l-.057.004H7.057a.057.057 0 00-.018.11l.018.003h2.994a.449.449 0 01.056.894l-.056.004H8.557a.057.057 0 00-.018.11l.018.003h2.492a.45.45 0 01.057.898l-.057.003H8.557a.057.057 0 00-.018.11l.018.004h1.994a.449.449 0 01.056.894l-.056.003H8.557a.057.057 0 00-.022.11l.022.004h.994a.449.449 0 01.057.894l-.057.003-3.49.002a3.5 3.5 0 01-1.809-.502l-.135-.085L3.5 11.5H3a.5.5 0 01-.496-.442L2.5 11V9.5a.5.5 0 01.442-.497L3 9h.5l.172-.343a2 2 0 01.896-.896l.107-.05L5 7.574h.002a1 1 0 001.99.05L7 7.548h1.55zM6 7a.5.5 0 110 1 .5.5 0 010-1zm1.56-4.092a.25.25 0 01.15.32l-.086.236 5.403 1.966a1.25 1.25 0 01-.855 2.35L6.769 5.813l-.086.235a.25.25 0 01-.47-.171l.257-.705 5.873 2.138a.75.75 0 00.513-1.41L6.983 3.763l.256-.705a.25.25 0 01.32-.15zm3.118 2.466l2.092.761a.5.5 0 11-.342.94L7.754 5.374h2.924z",
    fill: "currentColor"
  }));
};

exports.CausticCircleFilled = CausticCircleFilled;
var _default = CausticCircleFilled;
exports.default = _default;